const Upload = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 21.3333H19.9998V13.3333H25.3332L15.9998 4L6.6665 13.3333H11.9998V21.3333ZM15.9998 7.77333L18.8932 10.6667H17.3332V18.6667H14.6665V10.6667H13.1065L15.9998 7.77333ZM6.6665 24H25.3332V26.6667H6.6665V24Z"
        fill="#5A5955"
      />
    </svg>
  );
};

export default Upload;
